import VueRouter from 'vue-router'
import Vue from 'vue'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error)
}

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: () => import('../views/home.vue'),
  // },
  // {
  //   path: '/case',
  //   name: 'case',
  //   component: () => import('../views/customer-case/index.vue'),
  //   meta: {
  //     hideHeader: true,
  //     hideFooter: false,
  //   }
  // },
  // {
  //   path: '/introduce_meeting',
  //   name: 'introduce_meeting',
  //   component: () => import('../views/introduce_meeting.vue'),
  // },
  // {
  //   path: '/introduce_weclass',
  //   name: 'introduce_weclass',
  //   component: () => import('../views/introduce_weclass.vue'),
  // },
  // {
  //   path: '/introduce_meeting_platform',
  //   name: 'introduce_meeting_platform',
  //   component: () => import('../views/introduce_meeting_platform.vue'),
  // },
  // {
  //   path: '/news',
  //   name: 'news',
  //   component: () => import('../views/news/index.vue'),
  //   meta: {
  //     hideHeader: true,
  //     hideFooter: false,
  //   }
  // },
  // {
  //   path: '/news/detail/:id',
  //   name: 'newsDetail',
  //   component: () => import('../views/news/detail.vue'),
  //   meta: {
  //     hideHeader: true,
  //     hideFooter: false,
  //   }
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import('../views/about.vue'),
  //   meta: {
  //     hideHeader: true,
  //     hideFooter: false,
  //   }
  // },
  // {
  //   path: '/contact',
  //   name: 'contact',
  //   component: () => import('../views/contact.vue'),
  //   meta: {
  //     hideHeader: true,
  //     hideFooter: false,
  //   }
  // },
  {
    path: '/development',
    component: () => import('../views/development/index.vue'),
    meta: {
      hideFooterLink: true,
    }
  },
  {
    path: '/development/detail',
    name: 'developmentDetail',
    component: () => import('../views/development/detail.vue'),
    meta: {
      hideFooterLink: true,
    }
  },
  {
    path: '*',
    name: '404Error',
    component: () => import('../views/404.vue'),
    meta: {
      hideHeader: true,
      hideFooter: true,
    }
  }
]

const addPath = (routeNames, basePath, baseComponentPath, meta) => {
  for (let i = 0; i < routeNames.length; i++) {
    routes.push({
      path: `${basePath || '/'}${routeNames[i]}`,
      component: () => import(`../views${baseComponentPath}/${routeNames[i]}.vue`),
      meta,
    });
  }
}

// // 产品介绍
// const productsRoutes = ['ydlz', 'jstx', 'hdzb', 'hdbb', 'sssp', 'ssyy'];
// addPath(productsRoutes, '/product/', '/product');
// // 解决方案
// const resolutionRoutes = ['powerIndustry', 'onlineEducation', 'socialEntertainment', 'medicalTreatment', 'telemedicine', 'publicSecurityOrgans'];
// addPath(resolutionRoutes, '/resolution/', '/resolution');
// // 客户案例
// const caseRoutes = ['weiyi', 'syfyy', 'mtyw', 'hly', 'gjzyyglj', 'llkt', 'qxy', 'mgxt', 'wyykt', 'zgdx', 'zgyd', 'zglt', 'lxkj', 'wyyhy', 'zjhs'];
// addPath(
//   caseRoutes,
//   '/case/',
//   '/customer-case/details',
//   {
//     hideHeader: true,
//     hideFooter: false,
//   }
// );
const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})

export default router
